/**
 * Red-flag suspensions of reconstructed races (`manifest.time_base.suspensions`, contract C3).
 * Race time t excludes the stoppage: the Director holds video time (phase 'suspended') at race time t.
 * The displayed race clock and the local wall clock add Σ duration_s of the suspensions with t_s ≤ t.
 * Races without suspensions (FastF1) have none: every helper is then the identity.
 */
import type { Manifest } from '../bundle/manifest.gen.ts';

export interface Suspension {
  t: number;
  lap: number;
  durationS: number;
  clockFlag: string;
  clockResume: string;
  /** the hold window in Director video seconds (manifest) */
  videoS0: number;
  videoS1: number;
}

/** The race's suspensions sorted by t (defensive: a manifest without the field gives []). */
export function suspensionsOf(man: Manifest): Suspension[] {
  const raw = man.time_base.suspensions;
  if (!Array.isArray(raw)) return [];
  return raw
    .map((s) => ({
      t: s.t, lap: s.lap, durationS: s.duration_s, clockFlag: s.clock_flag, clockResume: s.clock_resume,
      videoS0: s.video_s0 ?? 0, videoS1: s.video_s1 ?? 0,
    }))
    .sort((a, b) => a.t - b.t);
}

/** Σ duration_s of the suspensions with t_s ≤ t: add it to race time for the displayed clocks. */
export function suspensionShift(sus: readonly Suspension[], t: number): number {
  let d = 0;
  for (const s of sus) if (s.t <= t) d += s.durationS;
  return d;
}

/** 'RED FLAG · 13:46–15:50' (scrub-bar tooltip / legend) */
export function suspensionLabel(s: Suspension): string {
  return `RED FLAG · ${s.clockFlag}–${s.clockResume}`;
}

/** The recap card text: 'RED FLAG · SUSPENDED 13:46 – 15:50' */
export function suspensionCardText(s: Suspension): string {
  return `RED FLAG · SUSPENDED ${s.clockFlag} – ${s.clockResume}`;
}
